import "./footer.component.css";
import Logo from "../assets/logo_text.png";
import { Link } from "react-router-dom";
import FacebookIcon from "../assets/socials/facebook.png";
import InstagramIcon from "../assets/socials/instagram.png";
import LinkedInIcon from "../assets/socials/linkedin.png";
import TwitchIcon from "../assets/socials/twitch.png";
import { useLanguage } from "../i18n/language.context";

function FooterComponent() {
    const { t: tr } = useLanguage();

    return <div id="footer">
        <div className="footer-inner">
            <div className="footer-brand">
                <Link to="/" className="no-hover">
                    <img src={Logo} alt="TCG Awards" width={200} />
                </Link>
                <span>{tr("ui.footer.tagline")}</span>
            </div>

            <div className="footer-socials" aria-label="Social media links">
                <span>{tr("ui.footer.follow")}</span>
                <div className="footer-social-row">
                    <a href="https://www.facebook.com/tcgawards" className="footer-social-btn" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><img src={FacebookIcon} alt="Facebook" /></a>
                    <a href="https://www.instagram.com/tcgawards" className="footer-social-btn" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><img src={InstagramIcon} alt="Instagram" /></a>
                    <a href="https://www.linkedin.com/company/tcgawards" className="footer-social-btn" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer"><img src={LinkedInIcon} alt="LinkedIn" /></a>
                    <a href="https://www.twitch.tv/tcgawards" className="footer-social-btn" aria-label="Twitch" target="_blank" rel="noopener noreferrer"><img src={TwitchIcon} alt="Twitch" /></a>
                </div>
            </div>

            <div className="footer-links">
                <Link to="/privacy" className="no-decoration">
                    <h6>{tr("ui.footer.privacy")}</h6>
                </Link>
                <Link to="/imprint" className="no-decoration">
                    <h6>{tr("ui.footer.imprint")}</h6>
                </Link>
            </div>
        </div>
    </div>
}

export default FooterComponent;